import React, { Children, useEffect, useState } from "react";
import Tree from "react-d3-tree";
import { useDispatch } from "react-redux";
import { Container, Card } from "reactstrap";
import { getAllPrograms } from "../../../store/slices/programsSlice";
import { useSelector } from "react-redux";

const TreeView = ({ reload, type }) => {
  const dispatch = useDispatch();

  const programs = useSelector((state) => state.programs.allProgramsData);
  const serviceDetails = useSelector((state) => state.services.serviceDetail);
  const programDetails = useSelector((state) => state.programs.programDetail);
  const [orgChart, setOrgChart] = useState({ name: "Null" });
  const client = useSelector((state) => state.clients.selectedClient);

  useEffect(() => {
    console.log("first mount");
    dispatch(
      getAllPrograms({
        getServiceData: true,
        getSubServiceData: true,
      })
    );
    console.log("mount 1");
  }, []);

  useEffect(() => {
    if (programs.length && type === "Services") {
      let filterData = {
        name: client?.label,
        children: programs?.map((program) => {
          return {
            name: program.name,
            children: program?.ProgramServices?.map((service) => {
              if (service.ID === serviceDetails.ID) {
                return {
                  name: service.name,
                  children: service?.subServiceMapping?.map((subService) => {
                    return {
                      name: subService?.SubService?.name,
                      children: [],
                    };
                  }),
                };
              } else {
                return [];
              }
            }),
          };
        }),
      };
      setOrgChart(filterData);
    } else if (programs.length && type === "Programs") {
      let filterData = {
        name: client?.label,
        children: programs?.map((program) => {
          if (program.ID === programDetails.ID) {
            return {
              name: program.name,
              children: program?.ProgramServices?.map((service) => {
                return {
                  name: service.name,
                  children: service?.subServiceMapping?.map((subService) => {
                    return {
                      name: subService?.SubService?.name,
                      children: [],
                    };
                  }),
                };
              }),
            };
          } else {
            return {
              name: program.name,
              children: [],
            };
          }
        }),
      };
      console.log(filterData, "tree");
      setOrgChart(filterData);
    }
  }, [programs, serviceDetails, programDetails, reload]);

  return (
    <section className="tree-view-container">
      <Card className="tree-view-card">
        <Tree
          data={orgChart}
          orientation={"vertical"}
          pathFunc={"step"}
          dimensions={{ height: 700, width: 700 }}
          translate={{ x: 700, y: 100 }}
          centeringTransitionDuration={500}
          separation={{ siblings: 4 }}
        ></Tree>
      </Card>
    </section>
  );
};

export default TreeView;
